import DateTimePicker from "react-native-ui-datepicker"
import dayjs from "dayjs"
import { View } from "react-native"
import { BFColors } from "@/constants/Colors"
import { Image } from "expo-image"

export interface DatePickerProps {
  currentDate?: Date | null
  onChange: (date?: Date) => void
}

export const DatePicker = ({ currentDate, onChange }: DatePickerProps) => {
  return (
    <View className="bg-grey rounded-lg p-2 shadow-md">
      <DatePickerBasic onChange={onChange} currentDate={currentDate} />
    </View>
  )
}

export const DatePickerBasic = ({
  currentDate,
  onChange,
  ...rest
}: DatePickerProps) => {
  const date = dayjs(currentDate)

  return (
    <DateTimePicker
      buttonPrevIcon={
        <Image
          source={require("@/assets/images/datepicker_arrow_left.png")}
          style={{
            width: 18,
            height: 18,
          }}
        />
      }
      buttonNextIcon={
        <Image
          source={require("@/assets/images/datepicker_arrow_right.png")}
          style={{
            width: 18,
            height: 18,
          }}
        />
      }
      mode={"single"}
      date={date}
      selectedItemColor={BFColors.calmBlue}
      // headerTextContainerStyle={{ opacity: 0.5 }}
      headerTextStyle={{
        color: BFColors.midnightBlue,
        fontSize: 16,
        fontWeight: "bold",
      }}
      onChange={({ date }) => {
        if (typeof date === "number" || typeof date === "string") {
          onChange(new Date(date))
        } else if (date instanceof Date) {
          onChange(date)
        } else {
          onChange(date?.toDate())
        }
      }}
      {...rest}
    />
  )
}
